module.exports = __webpack_public_path__ + "static/media/cloud.cc3497ad.svg";